import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  ButtonSection,
  CancelButton,
  Checkbox,
  CheckboxLabel,
  CheckboxSection,
  CheckboxText,
  Container,
  ContentSection,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  EditorContainer,
  ErrorMessage,
  FooterSection,
  FormGroup,
  LoadingState,
  PageTitle,
  SelectButton,
  SelectIcon,
  SelectValue,
  SubmitButton,
  TitleInput,
  TitleSection,
} from './AdminWriteLayoutStyles';
import RichTextEditor from '../../common/RichTextEditor';
import { uploadImages } from '../../../services/postApi';
import { getCommunityCategories, CommunityCategory as AdminPostCategory } from '../../../services/communityApi';
import { adminPostApi } from '../../../services/admin/adminPostApi';
import { getStudyCategoriesList } from '../../../services/studyCategoryApi';
import { searchLecturers, LecturerSearchItem } from '../../../services/lecturerSearchApi';
import { getAdminLectures } from '../../../services/admin/classApi';

interface AdminWriteComponentProps {
  onCancel?: () => void;
}

const AdminWriteComponent: React.FC<AdminWriteComponentProps> = ({ onCancel }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const postId = searchParams.get('id');

  const [categories, setCategories] = useState<AdminPostCategory[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [studyCategories, setStudyCategories] = useState<any[]>([]);
  const [selectedStudyCategory, setSelectedStudyCategory] = useState<number | null>(null);
  const [lecturers, setLecturers] = useState<LecturerSearchItem[]>([]);
  const [selectedLecturer, setSelectedLecturer] = useState<number | null>(null);
  const [lecturerSearchText, setLecturerSearchText] = useState('');
  const [lectures, setLectures] = useState<any[]>([]);
  const [selectedLecture, setSelectedLecture] = useState<number | null>(null);
  const [lectureSearchText, setLectureSearchText] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [isPinned, setIsPinned] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [pendingFiles, setPendingFiles] = useState<File[]>([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // 移댄뀒怨좊━ 紐⑸줉 議고쉶
  const fetchCategories = useCallback(async () => {
    try {
      const response = await getCommunityCategories();
      setCategories(response.data);
    } catch (err) {
      /// console.error('移댄뀒怨좊━ 紐⑸줉 議고쉶 ?ㅽ뙣:', err);
    }
  }, []);

  // ?ㅽ꽣??移댄뀒怨좊━ 紐⑸줉 議고쉶
  const fetchStudyCategories = useCallback(async () => {
    try {
      const response = await getStudyCategoriesList();
      setStudyCategories(response.data);
    } catch (err) {
      /// console.error('?ㅽ꽣??移댄뀒怨좊━ 紐⑸줉 議고쉶 ?ㅽ뙣:', err);
    }
  }, []);

  // 寃뚯떆湲 ?곗씠??議고쉶 (?섏젙 紐⑤뱶????
  const fetchPostData = useCallback(async (id: string) => {
    try {
      setIsLoading(true);
      const postData = await adminPostApi.getAdminPost(parseInt(id));

      /// console.log('遺덈윭??寃뚯떆湲 ?곗씠??', {postData});

      // 寃뚯떆湲 ?곗씠?곕? ?쇱뿉 ?ㅼ젙
      setTitle(postData.title);
      setContent(postData.content);
      setIsPinned((postData as any).pinned || false); // pinned ?곹깭 ?ㅼ젙

      // 移댄뀒怨좊━ ?대쫫??ID濡?李얘린
      const categoryName = postData.category;
      const category = categories.find(cat => cat.name === categoryName);
      if (category) {
        setSelectedCategory(category.id);
      }

      // ?ㅽ꽣??移댄뀒怨좊━ ?뺣낫 ?ㅼ젙 (postData??studyCategoryId媛 ?덈뒗 寃쎌슦)
      if (postData.studyCategoryId && studyCategories.length > 0) {
        const studyCategory = studyCategories.find(cat => cat.id === postData.studyCategoryId);
        if (studyCategory) {
          setSelectedStudyCategory(studyCategory.id);
        }
      }

      // 媛뺤뿰???뺣낫 ?ㅼ젙 (postData??lecturerId媛 ?덈뒗 寃쎌슦)
      if (postData.lecturerId) {
        setSelectedLecturer(postData.lecturerId);
        // 媛뺤뿰??紐⑸줉??癒쇱? 濡쒕뱶????媛뺤뿰???뺣낫 ?ㅼ젙
        try {
          const results = await searchLecturers('');
          setLecturers(results);

          // 媛뺤뿰???대쫫 ?ㅼ젙 (API?먯꽌 諛쏆? lecturerName ?ъ슜)
          if (postData.lecturerName) {
            setLecturerSearchText(postData.lecturerName);
          } else {
            // lecturerName???녿뒗 寃쎌슦 媛뺤뿰??紐⑸줉?먯꽌 李얘린
            const lecturer = results.find(lec => lec.id === postData.lecturerId);
            if (lecturer) {
              setLecturerSearchText(lecturer.name);
            }
          }
        } catch (err) {
          /// console.error('媛뺤뿰??紐⑸줉 議고쉶 ?ㅽ뙣:', err);
        }
      }

      // 媛뺤쓽 ?뺣낫 ?ㅼ젙 (postData??lectureId媛 ?덈뒗 寃쎌슦)
      if (postData.lectureId) {
        setSelectedLecture(postData.lectureId);
        // 媛뺤쓽 紐⑸줉??癒쇱? 濡쒕뱶????媛뺤쓽 ?뺣낫 ?ㅼ젙
        try {
          const response = await getAdminLectures({
            page: 0,
            size: 9999
          });
          setLectures(response.content);

          // 媛뺤쓽 ?대쫫 ?ㅼ젙 (API?먯꽌 諛쏆? lectureTitle ?ъ슜)
          if (postData.lectureTitle) {
            setLectureSearchText(postData.lectureTitle);
          } else {
            // lectureTitle???녿뒗 寃쎌슦 媛뺤쓽 紐⑸줉?먯꽌 李얘린
            const lecture = response.content.find(lec => lec.id === postData.lectureId);
            if (lecture) {
              setLectureSearchText(lecture.title);
            }
          }
        } catch (err) {
          /// console.error('媛뺤쓽 紐⑸줉 議고쉶 ?ㅽ뙣:', err);
        }
      }

      setIsEditMode(true);
    } catch (err) {
      /// console.error('寃뚯떆湲 ?곗씠??議고쉶 ?ㅽ뙣:', err);
      alert('게시글 데이터를 불러오는데 실패했습니다.');
    } finally {
      setIsLoading(false);
    }
  }, [categories, studyCategories]);

  useEffect(() => {
    fetchCategories();
    fetchStudyCategories();
  }, [fetchCategories, fetchStudyCategories]);

  // postId媛 ?덇퀬 移댄뀒怨좊━媛 濡쒕뱶????寃뚯떆湲 ?곗씠??議고쉶
  // ?ㅽ꽣??移댄뀒怨좊━???좏깮?ы빆?대?濡??꾩닔 議곌굔?먯꽌 ?쒖쇅
  useEffect(() => {
    // console.log('寃뚯떆湲 濡쒕뵫 議곌굔 ?뺤씤:', {
    //   postId,
    //   categoriesLength: categories.length,
    //   studyCategoriesLength: studyCategories.length
    // });

    if (postId) {
      /// console.log('寃뚯떆湲 ?곗씠??濡쒕뵫 ?쒖옉');
      fetchPostData(postId);
    } else {
      /// console.log('寃뚯떆湲 濡쒕뵫 議곌굔 誘몄땐議?);
    }
  }, [postId, categories, fetchPostData]);

  // ?몃? ?대┃ ???쒕∼?ㅼ슫 ?リ린
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest('[data-dropdown]')) {
        setShowCategoryDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // ?대?吏 ?낅줈???몃뱾??
  const handleImageUpload = async (files: FileList): Promise<string[]> => {
    const urls: string[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type.startsWith('image/')) {
        const url = URL.createObjectURL(file);
        urls.push(url);
      }
    }

    return urls;
  };

  // ??寃利?
  const validateForm = (): boolean => {
    const newErrors: Record<string, string> = {};

    if (!selectedCategory) {
      newErrors.category = '카테고리를 선택해주세요.';
    }

    // 紐⑤뱺 移댄뀒怨좊━?먯꽌 異붽? ?좏깮 ?꾩슂 ?놁쓬

    if (!title.trim()) {
      newErrors.title = '제목을 입력해주세요.';
    }
    if (!content.trim()) {
      newErrors.content = '내용을 입력해주세요.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 痍⑥냼 ?몃뱾??
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      navigate(-1);
    }
  };

  // ?쒖텧 ?몃뱾??
  const handleSubmit = async () => {
    if (!validateForm() || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      // Blob URL???쒕쾭 URL濡?援먯껜
      let finalHtml = content;
      if (pendingFiles.length > 0) {
        const dt = new DataTransfer();
        pendingFiles.forEach((f) => dt.items.add(f));
        const { data: uploaded } = await uploadImages(dt.files);
        const serverUrls: string[] = uploaded || [];
        const blobUrls = Array.from(new Set((finalHtml.match(/blob:[^"')\s>]+/g) || [])));
        blobUrls.forEach((blobUrl, idx) => {
          const targetUrl = serverUrls[idx];
          if (targetUrl) {
            const esc = blobUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const re = new RegExp(esc, 'g');
            finalHtml = finalHtml.replace(re, targetUrl);
          }
        });
      }

      // ?좏깮??移댄뀒怨좊━ ?뺣낫 媛?몄삤湲?
      const selectedCategoryData = categories.find(cat => cat.id === selectedCategory);
      if (!selectedCategoryData) {
        throw new Error('유효하지 않은 카테고리입니다');
      }

      // API ?붿껌 ?곗씠??援ъ꽦 (愿由ъ옄 API ?뺤떇)
      const postData: any = {
        postCategoryId: selectedCategory,
        title: title.trim(),
        content: finalHtml.trim(), // content ?꾨뱶 ?ъ슜
        pinned: isPinned,
        exposed: true,
      };

      // 紐⑤뱺 移댄뀒怨좊━?먯꽌 異붽? ?꾨뱶 ?꾩슂 ?놁쓬 (而ㅽ뵾梨쀬쓽 lecturerId, 媛뺤쓽 吏덈Ц??lectureId, ?ㅽ꽣?붿쓽 studyCategoryId 紐⑤몢 ?쒓굅)

      /// console.log('愿由ъ옄 寃뚯떆湲 ?묒꽦 ?곗씠??', {postData});

      // API ?몄텧 (?섏젙 紐⑤뱶?몄? ?묒꽦 紐⑤뱶?몄????곕씪)
      if (isEditMode && postId) {
        // 수정 모드 - PUT API 호출
        const updateData = {
          postCategoryId: postData.postCategoryId,
          title: postData.title,
          content: postData.content,
          pinned: postData.pinned,
          exposed: postData.exposed
        };

        // 紐⑤뱺 移댄뀒怨좊━?먯꽌 異붽? ?꾨뱶 ?꾩슂 ?놁쓬

        await adminPostApi.updateAdminPost(parseInt(postId), updateData);
        alert('게시글이 성공적으로 수정되었습니다');
      } else {
        // ?묒꽦 紐⑤뱶 - 愿由ъ옄 寃뚯떆湲 ?앹꽦 API ?몄텧
        const response = await adminPostApi.createAdminPost(postData);
        if (response.code === 200 && response.data) {
          alert('게시글이 성공적으로 작성되었습니다');
        } else {
          throw new Error(response.message || '게시글 작성에 실패했습니다.');
        }
      }

      navigate('/admin/community/admin-post');
    } catch (error) {
      /// console.error('寃뚯떆湲 ?묒꽦 ?ㅽ뙣:', error);

      let errorMessage = '게시글 작성에 실패했습니다.';

      if (error instanceof Error) {
        if (error.message.includes('Failed to fetch')) {
          errorMessage = '서버에 연결할 수 없습니다. 네트워크 연결을 확인해주세요.';
        } else if (error.message.includes('401')) {
          errorMessage = '로그인이 필요합니다. 다시 로그인해주세요.';
        } else if (error.message.includes('403')) {
          errorMessage = '게시글 작성 권한이 없습니다.';
        } else {
          errorMessage = error.message;
        }
      }

      alert(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  // ?좏깮??移댄뀒怨좊━ ?대쫫 媛?몄삤湲?
  const getSelectedCategoryName = () => {
    const category = categories.find(cat => cat.id === selectedCategory);
    return category?.name || '카테고리를 선택해주세요.';
  };

  // ?좏깮???ㅽ꽣??移댄뀒怨좊━ ?대쫫 媛?몄삤湲?
  const getSelectedStudyCategoryName = () => {
    const category = studyCategories.find(cat => cat.id === selectedStudyCategory);
    return category?.name || '스터디 카테고리를 선택해주세요.';
  };

  // ?좏깮??媛뺤뿰???대쫫 媛?몄삤湲?
  const getSelectedLecturerName = () => {
    if (lecturerSearchText) {
      return lecturerSearchText;
    }
    const lecturer = lecturers.find(lec => lec.id === selectedLecturer);
    return lecturer?.name || '강의자를 선택해주세요.';
  };

  // ?좏깮??媛뺤쓽 ?대쫫 媛?몄삤湲?
  const getSelectedLectureName = () => {
    if (lectureSearchText) {
      return lectureSearchText;
    }
    const lecture = lectures.find(lec => lec.id === selectedLecture);
    return lecture?.title || '강의를 선택해주세요.';
  };

  // 濡쒕뵫 以묒씪 ???쒖떆
  if (isLoading) {
    return (
      <Container>
        <TitleSection>
          <PageTitle>글 작성</PageTitle>
        </TitleSection>
        <ContentSection>
          <LoadingState>
            게시글을 불러오는 중..
          </LoadingState>
        </ContentSection>
      </Container>
    );
  }

  return (
    <Container>
      <TitleSection>
        <PageTitle>
          {isEditMode ? '글 수정' : '글 작성'}
        </PageTitle>
      </TitleSection>

      <ContentSection>
        {/* 카테고리 선택 */}
        <FormGroup>
          <Dropdown data-dropdown>
            <SelectButton
              $hasError={!!errors.category}
              onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
            >
              <SelectValue>{getSelectedCategoryName()}</SelectValue>
              <SelectIcon>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M2.46 5.13L8 10.87L13.54 5.13"
                    stroke="var(--Label-Alternative, rgba(55, 56, 60, 0.61))"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </SelectIcon>
            </SelectButton>

            {showCategoryDropdown && (
              <DropdownMenu>
                {categories.map((category) => (
                  <DropdownItem
                    key={category.id}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      setShowCategoryDropdown(false);
                      if (errors.category) {
                        setErrors(prev => {
                          const newErrors = { ...prev };
                          delete newErrors.category;
                          return newErrors;
                        });
                      }
                    }}
                  >
                    {category.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            )}
          </Dropdown>
          {errors.category && <ErrorMessage>{errors.category}</ErrorMessage>}
        </FormGroup>

        {/* 스터디 카테고리 선택 UI 제거됨 */}

        {/* 강의자 선택 UI 제거됨 */}

        {/* 강의 선택 UI 제거됨 */}

        {/* ?쒕ぉ ?낅젰 */}
        <FormGroup>
          <TitleInput
            type="text"
          placeholder='제목을 입력해주세요.'
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
              if (errors.title) {
                setErrors(prev => {
                  const newErrors = { ...prev };
                  delete newErrors.title;
                  return newErrors;
                });
              }
            }}
            $hasError={!!errors.title}
          />
          {errors.title && <ErrorMessage>{errors.title}</ErrorMessage>}
        </FormGroup>

        {/* ?먮뵒??*/}
        <FormGroup>
          <EditorContainer>
            <RichTextEditor
              value={content}
              onChange={(newContent) => {
                setContent(newContent);
                if (errors.content) {
                  setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors.content;
                    return newErrors;
                  });
                }
              }}
              placeholder='내용을 입력해주세요.'
              minHeight="300px"
              onImageUpload={handleImageUpload}
              attachedFiles={[]}
              onAttachedFilesChange={() => {}}
              attachmentsEditable={true}
              onPendingFilesChange={setPendingFiles}
            />
          </EditorContainer>
          {errors.content && <ErrorMessage>{errors.content}</ErrorMessage>}
        </FormGroup>

          {/* 하단 버튼 영역 */}
        <FooterSection>
          <CheckboxSection>
            <CheckboxLabel>
              <Checkbox
                type="checkbox"
                checked={isPinned}
                onChange={(e) => setIsPinned(e.target.checked)}
              />
              <CheckboxText>게시글 상단에 고정</CheckboxText>
            </CheckboxLabel>
          </CheckboxSection>
          <ButtonSection>
            <CancelButton
              type="button"
              onClick={handleCancel}
            >
              <span>취소</span>
            </CancelButton>
            <SubmitButton
              type="button"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting
                ? (isEditMode ? '수정 중..' : '등록 중..')
                : (isEditMode ? '수정하기' : '등록하기')
              }
            </SubmitButton>
          </ButtonSection>
        </FooterSection>
      </ContentSection>
    </Container>
  );
};

export default AdminWriteComponent;
